import notifyError from 'components/notification';
import useCheckoutPopup from 'hooks/useCheckoutPopup';
import { AnchorProps } from 'hooks/useCheckoutPopup/types';
import { useEventTracking, UpsellModal } from 'state/eventTracking';

export interface UseUpsellModalContentsConfigConfig {
  modalName: UpsellModal;
  errorMessage?: string;
  onSuccess?: () => void;
}

export interface UseUpsellModalContentsConfigResult {
  anchorProps: AnchorProps;
}

export default function useUpsellModalContentsConfigProps({
  modalName,
  errorMessage = 'Error processing checkout',
  onSuccess,
}: UseUpsellModalContentsConfigConfig): UseUpsellModalContentsConfigResult {
  const { trackUnlockThisFeature } = useEventTracking();

  const { anchorProps } = useCheckoutPopup({
    onOpen() {
      trackUnlockThisFeature({ modal: modalName });
    },
    onSuccess,
    onError() {
      notifyError({
        heading: errorMessage,
      });
    },
  });

  return {
    anchorProps,
  };
}
